module.exports = __webpack_public_path__ + "static/img/kepco-cs.27da6d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kepco-cs.jpg
// module id = I0WU
// module chunks = 0